import React, { Component } from 'react'
import './ProductKidsCustomize.css';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import{detailsKidsCustomize, doKidsCustomizeRes} from '../../../action/KidsCustomizeAction';
// import{showProductView, doProductViewRes} from '../../../action/ProductViewAction';
import{cartToAdd, doAddToCartRes} from '../../../action/AddToCartAction';
import {cartListView, doCartListRes} from '../../../action/CartListAction';
import { login_list, doLoginRes} from '../../../action/LoginAction';
import { createRegister, doRegisterRes} from '../../../action/RegisterAction';
import { productVariable, doVariableProductDetailsRes} from '../../../action/VariableProductDetailsAction';
import { UploadImageCustomize, doImageUploadCustomize } from '../../../action/ImageUploadCustomizeAction';
import Footer from '../../../component/Footer/Footer';
import LayoutWrapper from '../../../component/LayoutWrapper/';
import { Link } from 'react-router-dom';
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import LoginRegister from '../../LoginRegister/LoginRegister'
// import "~react-image-gallery/styles/css/image-gallery.css";
import "react-image-gallery/styles/css/image-gallery.css";
import Tshirt from './tshirt/tshirt';
// import Mobile from './mobile/mobile';
import loaderImg from '../../../assets/images/loader-example.gif';
import Loader from 'react-loader-advanced';
import parse from 'html-react-parser';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';


class ProductKidsCustomize extends Component {
    constructor(props){
        super(props);
        this.state={
            // sub_id: props.match.params.sub_id,
            product_type: 'customize',
            colorSet:'',
            sizeSet:'',
            sleeveSet:'',
            productViewData: [],
            brand:[],
            color:[],
            size: [],
            sleeve:[],
            qty:1,
            cartCheck: false,
            removeAdd: false,
            loginModalPopup: false,
            VariableProductData:[],
            photoData:[],
            imageUrl: '',
            imageUrlB: '',
            isLoader: false,
            is_varient: '1',
            imgobj : {
                imgNode:[null,null],
                img:['',''],
            },
            txtobj : {
                text:['',''],
                txtNode:[null,null],
                textP:[null,null],
                fontFamily:["Open Sans","Open Sans"],
                fontSize:[14,14],
                fontColor:['#000000','#000000'],
                alignment:['left','left']
            },
            setFB:'front',
            paintFront: 0,
            more_desc: '',
            imageUploadStatus: false
        }
        ReactGA.initialize('UA-64201999-5');
        ReactGA.pageview(window.location.pathname + window.location.search);

        ReactPixel.init('784849368913134');

        ReactPixel.pageView();
    }

    

    componentDidMount(){
        
        const data={
            // product_id: 0,
            product_type: 'customize',
        }
        this.setState({
            isLoader: true
        })
        this.props.detailsKidsCustomize(data)
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.doLoginRes && nextProps.doLoginRes.user){
            if(nextProps.doLoginRes.user && nextProps.doLoginRes.user.LoginRes){
                if(nextProps.doLoginRes.user.LoginRes && nextProps.doLoginRes.user.LoginRes.result === true){                   
                    this.setState({
                        loginModalPopup: false
                    })
                    
                } else{
                    this.setState({
                        loginModalPopup: false
                    })
                   
                }
            }
        }

        if(nextProps.doRegisterRes && nextProps.doRegisterRes.user){
            if(nextProps.doRegisterRes.user && nextProps.doRegisterRes.user.RegisterRes){
                if(nextProps.doRegisterRes.user.RegisterRes && nextProps.doRegisterRes.user.RegisterRes.result === true){                    
                    this.setState({
                        loginModalPopup: false
                    })
                }else{
                    this.setState({
                        loginModalPopup: false
                    })                   
                }
            }
        }

        if(nextProps.doKidsCustomizeRes && nextProps.doKidsCustomizeRes.user){
            if(nextProps.doKidsCustomizeRes.user && nextProps.doKidsCustomizeRes.user.KidsCustomizeRes){
                if(nextProps.doKidsCustomizeRes.user.KidsCustomizeRes && nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.result === true){
                    if(nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.data === null){
                        this.setState({
                            productViewData: [],
                            isLoader: false
                        })
                    } else{
                        this.setState({
                            productViewData: nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.data,
                            productType: nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.data[0].product_type,
                            brand:nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.brand,
                            color: nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.color,
                            size:nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.size,
                            sleeve:nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.sleeve,
                            more_desc: nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.more_desc,
                            isLoader: false
                        })
                        if(this.state.colorSet === ''){
                            this.setState({                            
                                colorSet: nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.data[0].color,
                            })
                        }
                        if(this.state.sizeSet === ''){
                            this.setState({                            
                                sizeSet:nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.data[0].size,
                            })
                        }
                        if(this.state.sleeveSet === ''){
                            this.setState({                            
                                sleeveSet:nextProps.doKidsCustomizeRes.user.KidsCustomizeRes.data[0].sleeve,
                            })
                        }
                    }
                }
            }
        }

        if(nextProps.doAddToCartRes && nextProps.doAddToCartRes.user){
            if(nextProps.doAddToCartRes.user && nextProps.doAddToCartRes.user.AddToCartRes){
                if(nextProps.doAddToCartRes.user.AddToCartRes && nextProps.doAddToCartRes.user.AddToCartRes.result === true && this.state.removeAdd === true){
                    this.props.history.push('/cart')
                    this.setState({
                        cartCheck:true,
                        removeAdd: false,
                        isLoader: false
                    },()=>{
                        if(this.state.cartCheck){
                            const cartData={
                                user_id : localStorage.getItem('userId')                                
                            }
                            this.setState({
                                isLoader: false
                            })
                                                     
                            this.props.cartListView(cartData)
                        }
                    })
                }
            }
        }

        if(nextProps.doVariableProductDetailsRes && nextProps.doVariableProductDetailsRes.user){
            if(nextProps.doVariableProductDetailsRes.user && nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes){
                if(nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes && nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.result === true){
                    this.setState({
                        productViewData: nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.data,
                        varientProductId: nextProps.doVariableProductDetailsRes.user.VariableProductDetailsRes.data[0].varient_product_id,
                        isLoader: false
                    })
                } else{
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }

        if(nextProps.doImageUploadCustomize && nextProps.doImageUploadCustomize.data){
            if(nextProps.doImageUploadCustomize.data && nextProps.doImageUploadCustomize.data.UploadImageRes){
                if(nextProps.doImageUploadCustomize.data.UploadImageRes && nextProps.doImageUploadCustomize.data.UploadImageRes.success === true && this.state.imageUploadStatus){
                    if(this.state.setFB === 'front'){
                        this.setState({
                            imageUrl : nextProps.doImageUploadCustomize.data.UploadImageRes.URL,
                            isLoader: false,
                            imageUploadStatus: false
                        })
                    }else{
                        this.setState({
                            imageUrlB : nextProps.doImageUploadCustomize.data.UploadImageRes.URL,
                            isLoader: false,
                            imageUploadStatus: false
                        })
                    }
                } else{
                    this.setState({
                        isLoader: false
                    })
                }
            }
        }


    }

    addtocart=(dataItem)=>{
                    // price:dataItem.sale_price,
        if(localStorage.getItem('userId')){
                
                const data={
                    user_id : localStorage.getItem('userId'),
                    product_id: 0,
                    product_variant_id: dataItem.varient_product_id,
                    qty: this.state.qty,
                    product_type: this.state.product_type,
                    text_json: JSON.stringify(this.state.txtobj),
                    image_json: JSON.stringify(this.state.imgobj),
                    is_varient: this.state.is_varient,
                    thumbnail: JSON.stringify(dataItem.thumbnailFront),
                    thumbnail_back: JSON.stringify(dataItem.thumbnailBack),
                    print_type : dataItem.print_type
                }
                this.setState({
                    removeAdd:true,
                    isLoader: true
                })
                this.props.cartToAdd(data)
                
                
           
            
           
        } else {
            this.getValue(true)
        }
        
    }

    onCloseModal= () =>{
        this.setState({
            loginModalPopup:false
        })
    }

    getValue = (e) => {        
        this.setState({
            loginModalPopup:e
        })
    }

    handleChangeColor=(e)=>{
        this.setState({
            colorSet: e.target.value,            
        },()=>{
            this.variableApi();
        })
    }

    handleChangeSize=(e)=>{
        this.setState({            
            sizeSet: e.target.value,            
        },()=>{
            this.variableApi();
        })
    }

    handleChangeSleeve=(e)=>{
        this.setState({            
            sleeveSet: e.target.value,            
        },()=>{
            this.variableApi();
        })
    }

    variableApi = (e) => {
        const data ={
            product_id: e.pId,
            Tvalue : e.color,
            Sizvalue: e.size,
            SleVvalue: e.sleeve,
            product_type: 'customize',
        }
        this.setState({
            isLoader: true
        })
        this.props.productVariable(data)
    }
    setQty = (e) => {
        this.setState({
            qty:e
        })
    }

    paintOn =(e)=>{        
        this.setState({
            paintFront:e
        })       
    }

    uploadImage=(e, p)=>{
        const imgData ={
            imageUpload : e[0]
        }
        this.setState({
            isLoader: true,
            setFB:p,
            imageUploadStatus: true
        },()=>{
            this.props.UploadImageCustomize(imgData)
        })

    }

    objSet = (t,i) =>{
        this.setState({
            imgobj:i,
            txtobj:t
        })
    }
    setLoader = (e) => {
        this.setState({
            isLoader:e
        })
    }

    remImg = (t) => {
        if(t){
            if(t === 'front'){
                this.setState({
                    imageUrl:''
                })
            }else if(t === 'back'){
                this.setState({
                    imageUrlB:''
                })
            }
        }
        
    }


    render() {
        const spinner = <span><img src={loaderImg} alt="" /></span>;
        
        return (
            <React.Fragment>
                
                <LayoutWrapper {...this.props} />
                 
                <Loader show={this.state.isLoader} message={spinner}> 
                
                    <main className="main main-container">
                        <nav aria-label="breadcrumb" className="breadcrumb-nav">
                            <div className="container">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    {this.state.productViewData && this.state.productViewData.map((item,i) =>(
                                    <li className="breadcrumb-item"  key={i}><Link to={'#'}>{item.name}</Link></li>))}
                                    
                                </ol>
                            </div>
                            {/* End .container */}
                        </nav>
                        {this.state.productViewData.length > 0 && 
                            <Tshirt remImg={this.remImg} setLoader={this.setLoader} objSet={this.objSet} tData={this.state.txtobj} iData={this.state.imgobj} ColorsData={this.state.color} variableApi={this.variableApi}  pData={this.state.productViewData} addToCart={this.addtocart} qty={this.state.qty} setQty={this.setQty} uploadImage={this.uploadImage} imageUrlData={this.state.imageUrl} imageUrlDataB={this.state.imageUrlB} SizeData={this.state.size} SleeveData={this.state.sleeve} paintOn={this.paintOn} paintFront={this.state.paintFront}/>
                            // <Mobile ColorsData={this.state.color}  pData={this.state.productViewData} addToCart={this.addtocart} qty={this.state.qty} setQty={this.setQty} />
                                
                            }
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">

                                    <div className="product-single-tabs">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item t-shirt-cstmz">
                                                <a className="description-a" id="product-tab-desc" data-toggle="tab" href="product.html#product-desc-content" role="tab" aria-controls="product-desc-content" aria-selected="true">Description</a>
                                            </li>
                                            
                                        </ul>
                                        <div className="tab-content">
                                            
                                                <div className="tab-pane fade show active"  id="product-desc-content" role="tabpanel" aria-labelledby="product-tab-desc">
                                                <div className="product-desc-content">
                                                    <div>{parse(''+this.state.more_desc+'')}</div>
                                                    <div>
                                                        <h4>
                                                            For Bulk Order 
                                                            <Link to="/contacts"        className="link-transform">
                                                            &nbsp;Contact Us
                                                            </Link>
                                                        </h4>
                                                    </div>
                                                </div>
                                                {/* End .product-desc-content */}
                                            </div>
                                           
                                            
                                            {/* End .tab-pane */}
                                            

                                            
                                        </div>
                                        {/* End .tab-content */}
                                    </div>
                                    {/* End .product-single-tabs */}
                                </div>
                                {/* End .col-md-3 */}
                            </div>
                            {/* End .row */}
                        </div>
                        {/* End .container */}

                        
                    </main>
                
                    {/* End .main */}
                    <Modal open={this.state.loginModalPopup} onClose={this.onCloseModal} >
                        <LoginRegister getValue={this.getValue}/>                                    
                    </Modal> 
                </Loader>
           {/* </LayoutWrapper>                                  */}
                <Footer />
            </React.Fragment>
        )
    }
}

ProductKidsCustomize.propTypes = {
    doKidsCustomizeRes: PropTypes.any,
    // doKidsCustomizeRes: PropTypes.any, 
    doAddToCartRes: PropTypes.any, 
    doCartListRes: PropTypes.any, 
    doLoginRes: PropTypes.any,
    doRegisterRes: PropTypes.any,
    doVariableProductDetailsRes: PropTypes.any,
    doImageUploadCustomize: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
    // doKidsCustomizeRes: doProductViewRes,
    doKidsCustomizeRes: doKidsCustomizeRes,
    doAddToCartRes: doAddToCartRes,
    doCartListRes: doCartListRes,
    doLoginRes:  doLoginRes,
    doRegisterRes: doRegisterRes,
    doVariableProductDetailsRes: doVariableProductDetailsRes,
    doImageUploadCustomize: doImageUploadCustomize
});

function mapDispatchToProps(dispatch) {
    return {
        // showProductView: (data) => dispatch(showProductView(data)),
        detailsKidsCustomize: (data) => dispatch(detailsKidsCustomize(data)),
        cartToAdd:(data) => dispatch(cartToAdd(data)),
        cartListView: (data) => dispatch(cartListView(data)),
        login_list: (data) => dispatch(login_list(data)),
        createRegister: (data) => dispatch(createRegister(data)),
        productVariable: (data) => dispatch(productVariable(data)),
        UploadImageCustomize: (data) => dispatch(UploadImageCustomize(data))
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default  compose(withConnect)(ProductKidsCustomize)